import ApiService from "@/core/services/api.service";

// NOTE: Endpoint names are based on existing conventions in this repo.
// If backend uses a different path, only PATH_IDP_EXAM_REGISTER needs adjusting.
export const PATH_IDP_EXAM_REGISTER = "academic/idp-exam-register";

export const GET_LIST_IDP_EXAM_REGISTER = "GET_LIST_IDP_EXAM_REGISTER";
export const GET_IDP_EXAM_REGISTER_DETAIL = "GET_IDP_EXAM_REGISTER_DETAIL";
export const CREATE_IDP_EXAM_REGISTER = "CREATE_IDP_EXAM_REGISTER";
export const UPDATE_IDP_EXAM_REGISTER = "UPDATE_IDP_EXAM_REGISTER";
export const DELETE_IDP_EXAM_REGISTER = "DELETE_IDP_EXAM_REGISTER";
export const EXPORT_IDP_EXAM_REGISTER = "EXPORT_IDP_EXAM_REGISTER";
export const PREVIEW_IMPORT_IDP_EXAM_REGISTER = "PREVIEW_IMPORT_IDP_EXAM_REGISTER";
export const IMPORT_IDP_EXAM_REGISTER = "IMPORT_IDP_EXAM_REGISTER";

const state = {};
const getters = {};

const actions = {
    [GET_LIST_IDP_EXAM_REGISTER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(PATH_IDP_EXAM_REGISTER, payload)
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response));
        });
    },
    [GET_IDP_EXAM_REGISTER_DETAIL](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${PATH_IDP_EXAM_REGISTER}/${payload.id}`)
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response));
        });
    },
    [CREATE_IDP_EXAM_REGISTER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(PATH_IDP_EXAM_REGISTER, payload)
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response));
        });
    },
    [UPDATE_IDP_EXAM_REGISTER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.put(PATH_IDP_EXAM_REGISTER, payload)
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response));
        });
    },
    [DELETE_IDP_EXAM_REGISTER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.delete(PATH_IDP_EXAM_REGISTER, payload.id)
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response));
        });
    },
    [EXPORT_IDP_EXAM_REGISTER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${PATH_IDP_EXAM_REGISTER}/export`, payload)
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response));
        });
    },
    [PREVIEW_IMPORT_IDP_EXAM_REGISTER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${PATH_IDP_EXAM_REGISTER}/preview-import`, payload)
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response));
        });
    },
    [IMPORT_IDP_EXAM_REGISTER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${PATH_IDP_EXAM_REGISTER}/import`, payload)
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response));
        });
    },
};

const mutations = {};

export default {
    state,
    actions,
    mutations,
    getters,
};

